module.exports = __webpack_public_path__ + "static/media/Bjurholmsvapen.5a5b67ea.png";